import TextBasedSectionContainer from '@/components/TextBasedSectionContainer'
import { useRouter } from 'next/router'
import { PageSEO } from '@/components/SEO'

export default function Games() {
  const router = useRouter()

  return (
    <>
      <PageSEO
        title={`Animerdle - All Games`}
        description={`All Animerdle games`}
        keywords={'anime games'}
      />
      <TextBasedSectionContainer title={'All Games'}>
        <div className="-m-4 flex flex-wrap">
          <div className="p-4 md:w-1/2 xl:w-1/3">
            <div className="hover prose rounded-lg border border-gray-300 p-6 shadow-md dark:prose-dark dark:border-gray-600 dark:shadow-sm dark:shadow-gray-500">
              <div className="flex flex-row space-x-4">
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-300 dark:bg-gray-700 dark:shadow-gray-800">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    stroke="currentColor"
                    strokeWidth="0"
                    fill="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M8 17H4.5q-.604 0-1.052-.448Q3 16.104 3 15.5V10q0-1.458.552-2.729.552-1.271 1.5-2.219t2.229-1.5Q8.562 3 10.021 3q1.437 0 2.708.552 1.271.552 2.219 1.5t1.5 2.219Q17 8.542 17 10v5.5q0 .604-.438 1.052Q16.125 17 15.5 17H12v-6h3.5v-1q0-2.292-1.604-3.896T10 4.5q-2.292 0-3.896 1.604T4.5 10v1H8Zm-1.5-4.5h-2v3h2Zm7 0v3h2v-3Zm0 0h2-2Zm-7 0h-2Z" />
                  </svg>
                </div>
                <button
                  onClick={() => {
                    router.push('/')
                  }}
                  className="inline-flex h-10 w-16 cursor-pointer items-center justify-center rounded-full bg-primary-600 shadow-sm duration-200 ease-in-out hover:bg-primary-700 dark:bg-primary-600 dark:shadow-gray-800 hover:dark:bg-primary-700"
                >
                  <span className="text-sm font-semibold text-white">PLAY</span>
                </button>
              </div>
              <h2>Animerdle</h2>
              <p>
                The original daily anime guessing game! Listen to audio clips and try to identify
                which anime the sound belongs to.
              </p>
            </div>
          </div>
        </div>
      </TextBasedSectionContainer>
    </>
  )
}
